export default "__VITE_ASSET__D9AVXi9Y__"